/* TOGGLE FUNCTION */
jQuery.fn.toggle_2 = function( fn, fn2 ) {
  // Don't mess with animation or css toggles
  // if ( !jQuery.isFunction( fn ) || !jQuery.isFunction( fn2 ) ) {
  //   return oldToggle.apply( this, arguments );
  // }
  // migrateWarn("jQuery.fn.toggle(handler, handler...) is deprecated");
  // Save reference to arguments for access in closure
  var args = arguments,
  guid = fn.guid || jQuery.guid++,
  i = 0,
  toggler = function( event ) {
    // Figure out which function to execute
    var lastToggle = ( jQuery._data( this, "lastToggle" + fn.guid ) || 0 ) % i;
    jQuery._data( this, "lastToggle" + fn.guid, lastToggle + 1 );
    // Make sure that clicks stop
    event.preventDefault();
    // and execute the function
    return args[ lastToggle ].apply( this, arguments ) || false;
  };
  // link all the functions, so any of them can unbind this click handler
  toggler.guid = guid;
  while ( i < args.length ) {
    args[ i++ ].guid = guid;
  } 
  return this.click( toggler );
};

function custom_filter(container, selector){
  container.find('.portfolio-item').each(function(){
    if(selector=="*"){
      $(this).show();
    }else{
      var $this = $(this);
      var classListTmp = $this.attr("class").split(' ');
      var classList = classListTmp.filter(function(v){return v!=='' && v!=='portfolio-item'});
      for ( var i = 0; i < classList.length; i++ )
      {
        if ( $this.hasClass(classList[i]) && $this.hasClass(selector)){
          $(this).show();
        }else{
          $(this).hide();
        }
      }
    }
  })
}

jQuery(window).load(function(){
  $("#status").fadeOut();
  $("#preloader").delay(1000).fadeOut('slow');

  // COUNTER  ------------------------------
 // $('.timer').countTo();
  // // MASONRY COLLECTIONS -----------------------
  if($('#shopify-section-list-collection').length > 0){
    // update columnWidth on window resize
    $(window).resize(function(){
      $('.portfolio-container').masonry({
        itemSelector:        '.portfolio-item',
        columnWidth:  ($('.portfolio-container').width() / 12)
      })
    });
    $('.portfolio-container').masonry({
        itemSelector:        '.portfolio-item',
        columnWidth:  ($('.portfolio-container').width() / 12)
      })
  }
  
  // // MASONRY BLOG -----------------------
  var $blog = $('.blog-articles-masonry-container');

  $blog.masonry({
    itemSelector : '.blog-article-masonry',
  });

  

});
jQuery(document).ready(function($) {

  // // MASONRY COLLECTIONS FILTER-----------------------
  $('.portfolio-filter a').click(function(){
    if ( $(this).hasClass('current-filter') ) {
      return false;
    }
    var container = $('.portfolio-container');
    var selector = $(this).attr('data-filter');
    custom_filter(container, selector);
    setTimeout(function(){$('.portfolio-container').masonry()}, 200);

    var $optionSet = $(this).parents('.portfolio-filter');
    $optionSet.find('.current-filter').removeClass('current-filter');
    $(this).addClass('current-filter');
  })

  if ( $( ".mega-menu" ).length ) {
    $(".mega-menu").width($('.header-container').width());
  }
  /* --------------------------------------------
   Platform detect
   --------------------------------------------- */
  var mobileTest;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
      mobileTest = true;
      $("html").addClass("mobile");
  }
  else {
      mobileTest = false;
      $("html").addClass("no-mobile");
  }

  // DRAG SLIDER -----------------------
  var dragFolio = $("#drag-carousel");
  var dragFolioRelated = $("#drag-carousel-related");
  var dragClients = $(".brand-list-carousel");
  var dragBlog = $(".blog-carousel-articles");

      dragClients.owlCarousel({
          autoplay: true,
          loop: true,
          items: 7,
          margin:1,
          responsive: {
              0: {items: 2},
              600: {items: 2},
              900: {items: 3},
              1000: {items: 5}
          }
      });

  // PORTFOLIO LIGHTBOX -----------------------
  $('.light-box').magnificPopup({
   type: 'image',
    mainClass: 'mfp-with-zoom', // this class is for CSS animation below
    closeBtnInside: true,
    closeOnContentClick: true,
    zoom: {
      enabled: true, // By default it's false, so don't forget to enable it
      duration: 300, // duration of the effect, in milliseconds
      easing: 'ease-in-out', // CSS transition easing function
      opener: function(openerElement) {
        // openerElement is the element on which popup was initialized, in this case its <a> tag
        // you don't need to add "opener" option if this code matches your needs, it's defailt one.
        return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  });

  // Accordion---------------------

  var allPanels = $(".m-accordion > dd").hide();
  allPanels.first().slideDown();
  $(".m-accordion > dt ").first().addClass("active");
  
  $(".m-accordion > dt ").click(function(){
  
      var current = $(this).next("dd");
      $(".m-accordion > dt").removeClass("active");
      $(this).addClass("active");
      allPanels.not(current).slideUp(200);
      $(this).next().slideDown(200);
      
      return false;
      
  });
  // TOGGLE -----------------------
  $(".m-toggle > dd").hide();
  $('.m-toggle>dt').toggle_2(function(){
      $(this).addClass('active');
      $(this).next().slideDown(300);
    },
    function(){
      $(this).removeClass('active');
      $(this).next().slideUp(300);
  });
  // TABS  ------------------------------
    tabby.init();
  // PROGRESS BAR --------------------------
  $('.m-pgs-bar-percent').each(function(){
    var progressPercent = $(this).data('percent');

    $(this).animate({width: progressPercent+'%'});
    $(this).prev().append(' '+progressPercent+'%');
  });
   $('.m-pgs-bar-thin-percent').each(function(){
    var progressPercent = $(this).data('percent');

    $(this).animate({width: progressPercent+'%'});
    $(this).next().append(' '+progressPercent+'%');
  });
  /* ---------------------------------------------
   Height 100%
   --------------------------------------------- */
  $(".full-height").height($(window).height());

  // HOVER EFFECTS -----------------------

  //PORTFOLIO
  $(".portfolio-item a, .portfolio-drag-item a").hover(function(){
      $(this).children(".portfolio-item-caption").stop().animate({opacity:1},200);
      $(this).children(".cap-bg").stop().animate({opacity:.9},200);
  }, function() {
      $(this).children(".portfolio-item-caption").stop().animate({opacity:0},200);
      $(this).children(".cap-bg").stop().animate({opacity:0},200);
  });

  // SEARCH MODAL --------------------
  $('.search-button, .search-btn-resp').click(function(){
    $('.search-modal').fadeIn();
    $('.search-modal-wrap').css('margin-top', 50);
  });
  $('#searchClose').click(function(){
    $('.search-modal').fadeOut();
    $('.search-modal-wrap').css('margin-top', 0);
  });
  // CART MODAL --------------------
 // $('.cart-button').click(function(){
 //   $('.cart-modal').fadeIn();
 //   $('.cart-modal-wrap').css('margin-top',50);
 // });
 //  $('.cart-button2').click(function(){
 //   $('.cart-modal').fadeIn();
 //   $('.cart-modal-wrap').css('margin-top', 50);
 // });
 // $('#cartClose').click(function(){
 //   $('.cart-modal').fadeOut();
 //   $('.cart-modal-wrap').css('margin-top',0 );
 // });
  // RESPONSIVE NAVIGATION  --------------------
  $('.responsive-trigger').toggle_2(function(){
    $(this).children('i').removeClass('icon-list2').addClass('icon-cross');
    $('.responsive-navigation').slideDown(300);
    },
    function(){
      $(this).children('i').removeClass('icon-cross').addClass('icon-list2');
      $('.responsive-navigation').slideUp(300);
  });
  // RESPONSIVE NAVIGATION  --------------------
  $('.submenu-trigger').toggle_2(function(){
    $(this).children('i').removeClass('icon-arrow-down5').addClass('icon-arrow-up4');
    $(this).next('ul').slideDown(300);
    },
    function(){
      $(this).children('i').removeClass('icon-arrow-up4').addClass('icon-arrow-down5');
      $(this).next('ul').slideUp(300);
  });
  // BUTTON STYLE SWITCHER --------------------
  $('.button-switcher').toggle_2(function(){
    $('.style-switcher').stop().animate({left:0},200);
    },
    function(){$('.style-switcher').stop().animate({left:"-50px"},200);
  });
  // LOCAL SCROLL --------------------------
  $.localScroll({
    target:'.body',
    offset: {left: 0, top: -70}
  });


  // BACK TO TOP  --------------------------
  $('#backTop').click(function(){
    $("html, body").animate({scrollTop:0},'slow');
    return false;
  });

  // FLEXSLIDER -----------------------
    $('.quote-slider, .quote-slider-white').flexslider({
      animation: "fade",
      directionNav: false
    });
    $('.blog-article-gallrey').flexslider({
      animation: "slide",
      controlNav: false
    });
    $('.blog-masonry-article-gallrey').flexslider({
      animation: "slide",
      controlNav: false
    });
    $('.project-media-gallrey').flexslider({
      animation: "slide",
      controlNav: false
    });
    $('.single-product-gallrey').flexslider({
      animation: "slide",
      animationSpeed: 300,
      directionNav: true,
      controlNav: "thumbnails"
    });
});


$(window).scroll(function() {
  // HEADER TRANSPARENT  SCROLL
  if ($(document).scrollTop() >= 90){  
    $('.home-t-h header').removeClass("transparent");
    $('.home-t-h-b header').removeClass("transparent-dark");
    if($('.home-t-h header').hasClass('white-header')){
      $('.logo').addClass('black-logo');
    }
  } 
  else{
    $('.home-t-h header').addClass("transparent");
    $('.home-t-h-b header').addClass("transparent-dark");
  }
  // //SELECTED MENU SCROLL --------------------
  if($('body').hasClass('home')){
    var currentNode = null;
    $('.section-area').each(function(){
      var currentId = jQuery(this).attr('id');    
      if(jQuery(window).scrollTop() >= jQuery('#'+currentId).offset().top - 95)
      {
        currentNode = currentId;
      }
    });
    $('.primary-navigation li').removeClass('selected').find('a[href="#'+currentNode+'"]').parent().addClass('selected');
  }
  // BACK TO TOP SHOW
  if ($(document).scrollTop() >= $(window).height()){  
    $('.back-to-top').show();
  }else{
    $('.back-to-top').hide();
  }
});

  // update columnWidth on window resize
$(window).resize(function(){

  if ( $( ".mega-menu" ).length ) {
    $(".mega-menu").width($('.header-container').width());
  }
  $(".full-height").height($(window).height());
});

// DISABLE HOVER ON SCROLL *******************
var body = document.body,
    timer;

window.addEventListener('scroll', function() {
  clearTimeout(timer);
  if(!body.classList.contains('disable-hover')) {
    body.classList.add('disable-hover')
  }
  
  timer = setTimeout(function(){
    body.classList.remove('disable-hover')
  },500);
}, false);

//***********************************
// Find all YouTube videos
var $allVideos = $("iframe[src^='//www.youtube.com'], iframe[src^='//www.youtube.com']"),

    // The element that is fluid width
    $fluidEl = $("body");

// Figure out and save aspect ratio for each video
$allVideos.each(function() {

  $(this)
    .data('aspectRatio', this.height / this.width)

    // and remove the hard coded width/height
    .removeAttr('height')
    .removeAttr('width');

});

// When the window is resized
$(window).resize(function() {

  var newWidth = $fluidEl.width();

  // Resize all videos according to their own aspect ratio
  $allVideos.each(function() {

    var $el = $(this);
    $el
      .width(newWidth)
      .height(newWidth * $el.data('aspectRatio'));

  });

// Kick off one resize to fix all videos on page load
}).resize();

$("#contactForm").validator().on("submit", function (event) {
    if (event.isDefaultPrevented()) {
        // handle the invalid form...
        formError();
        submitMSG(false, "Did you fill in the form properly?");
    } else {
        // everything looks good!
        event.preventDefault();
        submitForm();
    }
});

/******************* 
***** FORM SCRIPT  
*******************/
function submitForm(){
    // Initiate Variables With Form Content
    var name = $("#name").val();
    var email = $("#email").val();
    var message = $("#message").val();
}

function formSuccess(){
    $("#contactForm")[0].reset();
    submitMSG(true, "Message Submitted!")
}

function formError(){
    $("#contactForm").removeClass().addClass('shake animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass();
    });
}

function submitMSG(valid, msg){
    if(valid){
        var msgClasses = "align-center tada animated text-success";
    } else {
        var msgClasses = "align-center text-danger";
    }
    $("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
}